// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"bG-z","smallCardRow":"cG-z","largeCardRow":"dG-z","productSearchRow":"eG-z","curatedRow":"fG-z"};